module.exports = __webpack_public_path__ + "img/emoji_77.6ff457b7.png";